// path/filename: src/components/ContactSection/ContactSection.jsx

import React from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';

const ContactSection = () => {
  const handleEmailClick = () => {
    // Define the mailto link with subject and body
    const mailtoLink = `mailto:astromanishsingh@gmail.com?subject=Portfolio Connect&body=Hey! Waasup.`;
    // Open the default mail client with the mailto link
    window.location.href = mailtoLink;
  };

  return (
    <div id="connectSection">
      <Box sx={{ textAlign: 'center', my: 4 }}>
        <Typography variant="h6" gutterBottom>Email Me</Typography>
        <Typography sx={{ mb: 2 }}>astromanishsingh@gmail.com</Typography>
        <Typography variant="h6" gutterBottom>Based in</Typography>
        <Typography sx={{ mb: 2 }}>Varanasi, India</Typography>
        <Button
          variant="contained"
          size="medium"
          onClick={handleEmailClick} // Add onClick event handler
          sx={{
            backgroundColor: '#000',
            color: '#fff',
            borderRadius: '20px',
            py: 1,
            px: 3,
            textTransform: 'none',
            fontWeight: 'bold',
            boxShadow: 'none',
            '&:hover': { boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)' }
          }}
        >
          Drop a Line!
        </Button>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <IconButton aria-label="GitHub" href="https://www.github.com/astromanish" target="_blank" sx={{ mx: 1 }}>
            <GitHubIcon />
          </IconButton>
          <IconButton aria-label="LinkedIn" href="https://www.linkedin.com/in/astromanish" target="_blank" sx={{ mx: 1 }}>
            <LinkedInIcon />
          </IconButton>
          <IconButton aria-label="Twitter" href="https://www.twitter.com/_astromanish" target="_blank" sx={{ mx: 1 }}>
            <TwitterIcon />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default ContactSection;
